import _axios from '../../index'
import qs from 'qs'
//获取列表
export const orderData = (data) =>
    _axios({
        url: `/order/search?${qs.stringify(data)}`,
        method: 'get',
        // params: data
    })

//取消订单
export const orderToCancel = (data) =>
    _axios({
        url: '/order/cancel',
        method: 'put',
        params: data,
    })

//微信Pc支付轮询订单状态
export const orderWxSuccess = (params) =>
    _axios({
        url: '/order/wxSuccess',
        method: 'get',
        params,
    })

//退款记录
export const userOrderRefund = () =>
    _axios({
        url: '/order/userOrderRefund',
        method: 'get',
    })

//是否有转入订单.
export const userOrderInflow = () =>
    _axios({
        url: '/order/userOrderInflow',
        method: 'get',
    })

//是否有预充值记录.
export const userOrderPreRecharge = () =>
    _axios({
        url: '/order/userOrderPreRecharge',
        method: "get",
    });


//查询退款详情
export const getOrderInfo = params =>
    _axios({
        url: '/orderRefundApproval/findByOrderId',
        method: "get",
        params
    });
//取消退款
export const orderRefundCancel = (data) =>
    _axios({
        url: '/orderRefundApproval/cancel',
        method: 'put',
        headers: {
            'content-type': "application/json;charset=UTF-8"
        },
        data,
    })
//同意退款
export const orderRefundApproval = (data) =>
    _axios({
        url: '/orderRefundApproval/approval',
        method: 'put',
        headers: {
            'content-type': "application/json;charset=UTF-8"
        },
        data,
    })




//查询返还信息
export const getOrderReturnInfo = params =>
    _axios({
        url: '/orderReturnConfirm/findByRandomKey',
        method: "get",
        params,
        returnCatch:true
    });

//消费流水放弃退还
export const orderReturnCancel = data =>
    _axios({
        url: '/orderReturnConfirm/cancel',
        method: "put",
        data,
        returnCatch:true
    });

//消费流水确认反还
export const orderReturnConfirm = data =>
    _axios({
        url: '/orderReturnConfirm/confirm',
        method: "put",
        data,
        returnCatch:true
    });

